import { render, staticRenderFns } from "./tab-certify.vue?vue&type=template&id=3e7ce7fe"
import script from "./tab-certify.vue?vue&type=script&lang=js"
export * from "./tab-certify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports